import { Grid } from '@mui/material'
import React from 'react'
import './TitleInfo.css'
import ai from '../../assets/ai.png'
const TitleInfo = () => {
  return (
    <>
      <Grid className='titleInfo-container' container spacing={2}>
        <Grid className='containerLeft' item md={6}>
          <div className='left'>
            <div className="title">
              <span className='left-main-txt'>AI + Your Data = <br /></span><span className='main-text'>Self-aware Intelligent Machines</span>
            </div>
            <span className='info'>Our ChaitanyaAI is designed to handle large-scale data processing and analysis, enabling us to extract valuable patterns, trends, and correlations. By harnessing the power of your data, we can build robust and accurate models that deliver impactful results.</span>
          </div>
        </Grid>
        <Grid className='containerRight' item md={6}>
          <div className='logo-view'>
            <img className='logo' src={ai} alt="" />
          </div>
        </Grid>
      </Grid >
    </>
  )
}

export default TitleInfo